import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { QRCodeComponent } from 'angularx-qrcode';
import { ClipboardModule } from 'ngx-clipboard';
import { AppRoutingModule } from './app.routes';
import { HomeComponent } from './features/home/home.component';
import { MyLinksComponent } from './features/my-links/my-links.component';
import { InterceptorService } from './core/services/sl-auth-secure.interceptor';
import { StableLinkIntegrationService } from './core/services/stable-link-integration.service';
import {OAuthModule} from 'angular-oauth2-oidc'
import { NgxPaginationModule} from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';
import { AboutDialogComponent } from './features/about-dialog/about-dialog.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { CustomTooltipDirective } from './shared/directives/custom-tooltip.directive';
import { ShareDialogComponent } from './shared/components/share-dialog/share-dialog.component';
import { NotificationsModalComponent } from './shared/components/notifications-modal/notifications-modal.component';
import { ProfileComponent } from './features/profile/profile.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MyLinksComponent,
    AboutDialogComponent,
    HeaderComponent,
    FooterComponent,
    CustomTooltipDirective,
    ShareDialogComponent,
    ProfileComponent
  ],
  imports: [  BrowserModule,
              OrderModule,
              HttpClientModule,
              FormsModule,
              QRCodeComponent,
              ClipboardModule,
              AppRoutingModule,
              OAuthModule.forRoot(),
              NgxPaginationModule,
              NotificationsModalComponent,
            ],
  providers: [
    StableLinkIntegrationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]

})
export class AppModule {}
